import { Component } from '@verndale/core';
import Swiper from 'swiper/js/swiper';
import { nanoid } from 'nanoid';

import breakpoints from '../utils/breakpoints';
import { getGenericSliderConfig } from '../utils/slider';

class SmallCards extends Component {
  setupDefaults() {
    this.dom = {
      $heading: this.el._$('h2'),
      $rightFade: this.el._$('.small-cards__right-fade'),
      $leftFade: this.el._$('.small-cards__left-fade'),
      $slides: this.el._$$('.swiper-slide'),
      $swiperContainer: this.el._$('.swiper-container')
    };

    this.initSlider();
  }

  initSlider() {
    const { $swiperContainer, $slides, $rightFade, $leftFade, $heading } =
      this.dom;

    const slidesPerViewLg = !$swiperContainer.closest('.big-wrapper') ? 4 : 3;
    const slidesPerViewTablet = !$swiperContainer.closest('.big-wrapper')
      ? 3
      : 2;

    if ($slides.length <= slidesPerViewLg) {
      $leftFade.hidden = true;
      $rightFade.hidden = true;
    }

    $slides.forEach((slide) => {
      const $heading = slide._$('h3');
      const $article = slide._$('article');
      const id = `id-${nanoid()}`;

      if ($heading && $article) {
        $heading.id = id;
        $article.setAttribute('aria-labelledby', id);
      }
    });

    const element = this.el;

    this.swiper = new Swiper($swiperContainer, {
      ...getGenericSliderConfig(element, $heading),
      watchOverflow: true,
      slidesPerView: 1,
      spaceBetween: 25,
      watchSlidesProgress: true,
      watchSlidesVisibility: true,
      breakpoints: {
        [breakpoints.tablet]: {
          slideToClickedSlide: false,
          slidesPerView: slidesPerViewTablet,
          spaceBetween: 25
        },
        [breakpoints.lg]: {
          slideToClickedSlide: false,
          slidesPerView: slidesPerViewLg,
          spaceBetween: 0
        }
      },
      on: {
        init() {
          $swiperContainer.classList.remove('loading');
          $swiperContainer.classList.add('loaded');
        },
        ...($rightFade &&
          $leftFade &&
          /* eslint-disable indent */
          $slides.length > slidesPerViewLg && {
            activeIndexChange() {
              $leftFade.hidden = false;
              $rightFade.hidden = false;

              if (this.isBeginning) {
                $leftFade.hidden = true;
              }

              if (this.isEnd) {
                $rightFade.hidden = true;
              }
            }
          })
        /* eslint-enable indent */
      }
    });
  }
}

export default SmallCards;
